import React from 'react';

const GrunddatenForm = ({ formData, handleInputChange, errors, renderFieldErrors }) => {
  return (
    <div className="form-section">
      <h3 className="section-title">Grunddaten</h3>

      <div className="form-row">
        <div className="form-field full-width">
          <label htmlFor="transaktion-input">Transaktion <span className="required-star">*</span></label>
          <input
            id="transaktion-input"
            type="text"
            value={formData.transaktion}
            onChange={(e) => handleInputChange('transaktion', e.target.value)}
            className={errors.transaktion ? 'error' : ''}
            placeholder=""
            title="Grünheide (Mark), Büro am See, Will-Reich-Werden GmbH & Co"
          />
          {renderFieldErrors('transaktion')}
        </div>
      </div>

      <div className="form-row">
        <div className="form-field full-width">
          <label htmlFor="kommentare-input">Kommentare</label>
          <textarea
            id="kommentare-input"
            value={formData.kommentare}
            onChange={(e) => handleInputChange('kommentare', e.target.value)}
            className={errors.kommentare ? 'error' : ''}
            placeholder=""
            title="Aktivkonto: 5511003312, Passivkonto: 345014863, gesamtschuldnerische Haftung"
            rows="2"
          />
        </div>
      </div>
    </div>
  );
};

export default GrunddatenForm;
